import { filter, map, Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { AdditionalServiceCategoriesGQL, AdditionalServiceCategory, Maybe } from '@iss/libs/graphql';
import { FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import {
  Component,
  Inject,
  inject,
  Input,
  OnChanges,
  OnInit,
  Self,
  SimpleChanges,
} from '@angular/core';

import { AdditionalService, AdditionalServices } from './added-service-input.types';

import { TypeaheadSelectComponent } from '@iss/core/typeahead-select';
import { Control, NOOP_VALUE_ACCESSOR } from '@iss/core/forms';

@Component({
  selector: 'wo-added-service-input',
  templateUrl: './added-service-input.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    TypeaheadSelectComponent,
  ],
})
export class AddedServiceInputComponent implements OnInit, OnChanges {
  private readonly query = inject(AdditionalServiceCategoriesGQL);

  public loading$!: Observable<boolean>;
  public items$!: Observable<AdditionalServices>;

  public readonly stringify = (items: AdditionalServices | null): (code: AdditionalService['code']) => string =>
    code => items?.find(item => item.code === code)?.presentedName || '';

  public readonly matcher = (item: AdditionalService): string => item.presentedName;

  public readonly content = (code: AdditionalService['code'], items: AdditionalServices | null): string | undefined =>
    items?.find(item => item.code === code)?.presentedName;

  public readonly identity = (item: AdditionalService): AdditionalService['code'] => item.code;

  public constructor(
    @Self() @Inject(NgControl) public readonly control: Control<FormControl<AdditionalService['code']>>,
  ) {
    this.control.valueAccessor = NOOP_VALUE_ACCESSOR;
  }

  @Input() public readonly: Maybe<boolean>;
  @Input() public loading: Maybe<boolean>;
  @Input() public omit: Maybe<readonly AdditionalServiceCategory['code'][]>;

  public ngOnInit(): void {
    this.initQuery();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if ('omit' in changes) {
      this.initQuery();
    }
  }

  private initQuery(): void {
    const query$ = this.query.watch().valueChanges;

    this.loading$ = query$.pipe(map(({ loading }) => loading));
    this.items$ = query$.pipe(
      filter(({ data }) => Boolean(data)),
      map(({ data }) => this.omit ? data.additionalServiceCategories.filter(x => !this.omit!.includes(x.code)) : data.additionalServiceCategories),
    );
  }
}
